import { API_VERSION_ESYMANDANT, fetchHandler, fetchRequestBuilderFixedToken, HTTP_METHOD, limiter } from 'application/api/request_builders'
import { handleApiResponse } from 'application/api/response_handlers'

export const getRegistrationKey = (accountId, userId, token) => {

    const request = fetchRequestBuilderFixedToken(API_VERSION_ESYMANDANT + '/e.consult.' + accountId + '/user/' + userId + '/register', HTTP_METHOD.GET, {}, true, false, false, token)

    return limiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiResponse)
}